import { createContext } from 'react';

import { Notification } from '../types/Notification';
import { NotifyFunction } from '../types/NotifyFunction';

interface NotificationContext {
    notify: NotifyFunction;
    notifications: Notification[];
}

export const NotificationContext = createContext<NotificationContext>({
    notifications: [],
    notify: () => {},
});
